// Catat Hasil Saya — dialog operator (HP: lembar bawah penuh). Hanya 2 isian: jumlah baju & TOTAL titik (tanpa dikalikan).
// Simpan Hasil ≠ Selesai Bordir (dua tindakan terpisah). Klaim operator lain terkunci.
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Lock, CheckCircle2, Info } from "lucide-react";
import "./bordir_claims.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
export const errText = (e) => e?.response?.data?.detail || e?.message || "Gagal menyimpan";
const STATUS = { valid: "Tercatat", menunggu_validasi: "Menunggu Validasi", cancelled: "Dibatalkan" };
const FLAG = { titik_belum_terdaftar: "Titik pesanan belum terdaftar", jumlah_baju_belum_terbaca: "Jumlah baju belum terbaca" };
const SHIFT = { siang: "Siang", malam: "Malam" };

export function claimInvalid(pcs, titik, item) {
  const p = Number(pcs), t = Number(titik);
  if (!Number.isInteger(p) || p < 1) return "Isi jumlah baju yang Anda bordir";
  if (!Number.isInteger(t) || t < 1) return "Isi total titik bordir yang Anda kerjakan";
  if (item?.pcs_total && p > item.pcs_total) return `Maksimal ${item.pcs_total} pcs`;
  if (item?.remaining != null && t > item.remaining) return `Melebihi sisa titik pesanan (${item.remaining} titik)`;
  return "";
}

export const claimText = (c) => c.titik_total != null || c.titik_per_pcs == null
  ? `${c.pcs} pcs · ${c.units} titik bordir` : `${c.pcs} pcs × ${c.titik_per_pcs} titik = ${c.units}`;

export function Notice({ tone = "info", children, testid }) {
  return <div className={`bcl-notice bcl-${tone}`} data-testid={testid}><Info size={18} /> <div>{children}</div></div>;
}

function ClaimRow({ c, reload }) {
  const act = async (kind) => {
    const reason = window.prompt(kind === "cancel" ? "Alasan membatalkan hasil ini (wajib):" : "Alasan koreksi (wajib):");
    if (!reason || reason.trim().length < 3) return;
    try {
      if (kind === "cancel") await axios.post(`${API}/bordir-claims/${c.id}/cancel`, { reason }, { withCredentials: true });
      else {
        const pcs = Number(window.prompt("Jumlah baju yang benar:", c.pcs)), titik = Number(window.prompt("Total titik bordir yang benar:", c.units));
        if (!pcs || !titik) return;
        await axios.patch(`${API}/bordir-claims/${c.id}`, { pcs, titik, reason }, { withCredentials: true });
      }
      reload();
    } catch (e) { window.alert(errText(e)); }
  };
  return <div className={`bcl-row${c.status === "cancelled" ? " bcl-off" : ""}`} data-testid={`claim-row-${c.id}`}>
    <div className="bcl-row-main">
      <b>{c.operator_name}</b> {c.mine ? <span className="bcl-tag bcl-mine" data-testid={`claim-mine-${c.id}`}>Milik Anda</span>
        : <span className="bcl-tag" data-testid={`claim-locked-${c.id}`}><Lock size={11} /> tidak bisa diubah</span>}
      <div data-testid={`claim-row-text-${c.id}`}>{claimText(c)}</div>
      <small>Shift {SHIFT[c.shift] || c.shift} · {c.work_date} · {STATUS[c.status]}{c.corrected ? " · Dikoreksi" : ""}</small>
      {(c.flags || []).map(f => <span key={f} className="bcl-tag bcl-flag" data-testid={`claim-flag-${f}-${c.id}`}>{FLAG[f] || f}</span>)}
    </div>
    {c.can_edit && <div className="bcl-row-act">
      <button className="soft-btn small-btn" onClick={() => act("fix")} data-testid={`claim-fix-${c.id}`}>Koreksi</button>
      <button className="soft-btn small-btn" onClick={() => act("cancel")} data-testid={`claim-cancel-${c.id}`}>Batal</button>
    </div>}
  </div>;
}

function OwnerTitikFix({ it, reload }) {
  const [msg, setMsg] = useState("");
  const fix = async () => {
    const t = Number(window.prompt(`Titik per baju pesanan yang benar (sekarang ${it.declared_titik?.titik}, diisi ${it.declared_titik?.by}):`, it.declared_titik?.titik || ""));
    if (!t) return;
    const reason = window.prompt("Alasan koreksi (wajib):", "");
    if (!reason || reason.trim().length < 3) return;
    try { await axios.post(`${API}/bordir-claims/order-titik`, { order_number: it.order_number, product_id: it.product_id, titik: t, reason }, { withCredentials: true }); setMsg("Titik pesanan dikoreksi."); reload(); }
    catch (e) { setMsg(errText(e)); }
  };
  return <div className="bcl-short" data-testid="claim-owner-titik">
    <Notice tone="warn">Titik pesanan belum terdaftar — diisi operator <b>{it.declared_titik?.by}</b>: {it.declared_titik?.titik} titik per baju.</Notice>
    <button className="soft-btn" onClick={fix} data-testid="claim-owner-titik-fix">Koreksi Titik Pesanan</button>
    {msg && <small data-testid="claim-owner-titik-msg">{msg}</small>}
  </div>;
}

function ShortfallForm({ it, reload }) {
  const [reason, setReason] = useState("");
  const [msg, setMsg] = useState("");
  const send = async () => {
    try {
      await axios.post(`${API}/bordir-claims/${it.is_supervisor ? "finish-authorize" : "finish-request"}`,
        { order_number: it.order_number, product_id: it.product_id, reason }, { withCredentials: true });
      setMsg(it.is_supervisor ? "Otorisasi tersimpan — operator dapat menekan Selesai Bordir." : "Terkirim. Tunggu persetujuan Owner/Admin, lalu tekan Selesai Bordir lagi.");
      setReason(""); reload();
    } catch (e) { setMsg(errText(e)); }
  };
  return <div className="bcl-short" data-testid="claim-finish-shortfall">
    <Notice tone="warn">Masih ada selisih: <b>{it.shortfall}</b>. Selesai Bordir perlu {it.is_supervisor ? "otorisasi Anda" : "persetujuan Owner/Admin"}.</Notice>
    {it.finish_request && <small>Pengajuan: {it.finish_request.by} — {it.finish_request.reason}</small>}
    {it.finish_auth && <small className="bcl-ok">Disetujui {it.finish_auth.by}: {it.finish_auth.reason}</small>}
    <textarea rows={2} value={reason} onChange={e => setReason(e.target.value)} placeholder="Tulis alasan selisih" data-testid="claim-finish-reason" />
    <button className="soft-btn" disabled={reason.trim().length < 5} onClick={send} data-testid="claim-finish-send">{it.is_supervisor ? "Setujui Selesai dengan Selisih" : "Kirim ke Owner/Admin"}</button>
    {msg && <small data-testid="claim-finish-msg">{msg}</small>}
  </div>;
}

function FinishBox({ it, reload, onChanged }) {
  const [step, setStep] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  if (it.finished) return <Notice tone="ok" testid="claim-finished">Sudah Selesai Bordir oleh <b>{it.finished.by}</b> · Shift {SHIFT[it.finished.shift] || it.finished.shift} · {it.finished.work_date}</Notice>;
  if (!it.claim_mode || !it.eligible) return null;
  const go = async () => {
    if (busy) return;
    setBusy(true); setMsg("");
    try {
      await axios.post(`${API}/bordir-claims/finish`, { order_number: it.order_number, product_id: it.product_id, confirm_physical: true }, { withCredentials: true, timeout: 30_000 });
      setStep(false); await reload(); onChanged && onChanged();
    } catch (e) { setMsg(errText(e)); await reload(); }
    finally { setBusy(false); }
  };
  const blocked = it.shortfall && !it.finish_auth;
  return <div className="bcl-finish" data-testid="claim-finish-box">
    <b>Selesai Bordir</b>
    <small>Tekan hanya bila SEMUA baju pesanan ini sudah selesai dibordir. Hasil yang sudah dicatat tetap tersimpan.</small>
    {blocked && !it.is_supervisor ? <ShortfallForm it={it} reload={reload} /> : it.is_supervisor ? (it.shortfall ? <ShortfallForm it={it} reload={reload} /> : null) : !step
      ? <button className="soft-btn bcl-finish-btn" onClick={() => setStep(true)} data-testid="claim-finish-open"><CheckCircle2 size={16} /> Selesai Bordir</button>
      : <div className="bcl-confirm" data-testid="claim-finish-confirm">
        <div>Semua baju sudah selesai dibordir secara fisik?</div>
        <div className="bcl-actions">
          <button className="soft-btn" onClick={() => setStep(false)} disabled={busy} data-testid="claim-finish-back">Belum</button>
          <button className="primary bcl-green" onClick={go} disabled={busy} data-testid="claim-finish-yes">{busy ? "Menyimpan…" : "Ya, Semua Sudah Selesai"}</button>
        </div>
      </div>}
    {msg && <small className="bcl-err" data-testid="claim-finish-error">{msg}</small>}
  </div>;
}

// Offline & Shopee: titik terisi otomatis = pcs × titik/baju bila titik pesanan tercatat & seragam; tetap bisa diubah.
export function autoTitik(it, pcs) {
  const n = Number(pcs), t = it?.max_titik_per_pcs;
  if (!it?.titik_registered || !Number.isInteger(n) || n < 1 || !t || !it.pcs_total) return null;
  if (it.capacity !== it.pcs_total * t) return null;
  return it.remaining != null ? Math.max(0, Math.min(n * t, it.remaining)) : n * t;
}
export const titikMixed = (it) => !!it?.titik_registered && !!it.pcs_total && !!it.max_titik_per_pcs && it.capacity !== it.pcs_total * it.max_titik_per_pcs;

export const targetText = (n, unit) => (n ? `${n} ${unit}` : "Belum tercatat");

function Field({ label, value, onChange, target, testid }) {
  return <div className="bcl-q">
    <div className="bcl-q-label">{label}</div>
    <div className="bcl-q-row">
      <input type="number" min={1} inputMode="numeric" pattern="[0-9]*" value={value} onChange={e => onChange(e.target.value)} data-testid={testid} />
      <div className="bcl-target" data-testid={`${testid}-target`}><small>Target pesanan</small><b>{target}</b></div>
    </div>
  </div>;
}

function Inputs({ it, pcs, setPcs, titik, setTitik, auto }) {
  return <>
    <Field label="Berapa baju yang saya bordir?" value={pcs} onChange={setPcs} target={targetText(it.target_pcs, "pcs")} testid="claim-pcs" />
    <Field label="Berapa total titik bordir yang saya kerjakan?" value={titik} onChange={setTitik} target={targetText(it.target_titik, "titik")} testid="claim-titik" />
    {auto && <small className="bcl-sub" data-testid="claim-titik-auto">Terisi otomatis: {pcs} baju × {it.max_titik_per_pcs} titik — ubah bila berbeda</small>}
    {titikMixed(it) && <small className="bcl-sub" data-testid="claim-titik-mixed">Titik per variasi berbeda — isi total titik sesuai baju yang Anda kerjakan</small>}
    {it.target_titik != null && <small className="bcl-sub" data-testid="claim-summary">Sisa titik pesanan: <b data-testid="claim-remaining">{it.remaining}</b> dari {it.capacity}</small>}
  </>;
}

export const hasMineOf = (it) => (it?.claims || []).some(c => c.mine && c.status !== "cancelled");

export function ClaimDialog({ orderNumber, productId, label, onClose, onChanged, finalize }) {
  const [it, setIt] = useState(null);
  const [pcs, setPcs] = useState("");
  const [titik, setTitikRaw] = useState("");
  const manual = useRef(false);
  const setTitik = (v) => { manual.current = true; setTitikRaw(v); };
  const onPcs = (v) => { setPcs(v); if (!manual.current) { const a = autoTitik(it, v); setTitikRaw(a ? String(a) : ""); } };
  const isAuto = !manual.current && !!titik && autoTitik(it, pcs) === Number(titik);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const key = useRef(newKey());
  const inflight = useRef(false);
  const load = useCallback(() => axios.get(`${API}/bordir-claims/item`, { params: { order_number: orderNumber, product_id: productId }, withCredentials: true })
    .then(r => setIt(r.data)).catch(e => setErr(errText(e))), [orderNumber, productId]);
  useEffect(() => { load(); }, [load]);
  const full = it?.capacity != null && it.remaining <= 0;
  const finishOnly = !!finalize?.finish && hasMineOf(it);   // Selesai: hasil saya sudah tercatat → cukup tombol Selesai
  const canInput = it && !it.is_supervisor && it.eligible && !full && !finishOnly;
  const invalid = canInput ? claimInvalid(pcs, titik, it) : "x";
  const runFinalize = async () => {
    try {
      if (finalize.run) await finalize.run();
      else await axios.post(`${API}${finalize.path}`, { order_number: orderNumber, product_id: productId }, { withCredentials: true });
      if (finalize.note) window.alert(finalize.note);
      finalize.onDone();
    } catch (e) { setErr(errText(e)); }
  };
  const hasMine = hasMineOf(it);
  const save = async () => {
    if (inflight.current || invalid) return;
    inflight.current = true;
    setBusy(true); setErr(""); setOk("");
    try {
      const r = await axios.post(`${API}/bordir-claims`, { order_number: orderNumber, product_id: productId, pcs: Number(pcs), titik: Number(titik), request_id: key.current }, { withCredentials: true, timeout: 30_000 });
      key.current = newKey();
      setOk(`Tersimpan: ${claimText(r.data.claim)}`);
      setPcs(""); setTitikRaw(""); manual.current = false; await load(); onChanged && onChanged();
      if (finalize) await runFinalize();
    } catch (e) { setErr(errText(e)); if (e?.response) key.current = newKey(); }
    finally { inflight.current = false; setBusy(false); }
  };
  return <div className="bcl-backdrop" onClick={e => { e.stopPropagation(); if (!busy) onClose(); }} data-testid="claim-dialog">
    <div className="bcl-sheet" onClick={e => e.stopPropagation()}>
      <div className="bcl-head"><b>Catat Hasil Bordir</b><button className="soft-btn small-btn" onClick={onClose} disabled={busy} data-testid="claim-close">Tutup</button></div>
      <small className="bcl-sub">{label || `${orderNumber} · ${it?.product_name || ""}`}</small>
      {!it && !err && <small data-testid="claim-loading">Memuat…</small>}
      {it && !it.eligible && !it.finished && <Notice tone="warn" testid="claim-not-eligible">{it.reason}</Notice>}
      {it && it.eligible && full && !it.finished && <Notice tone="ok" testid="claim-full">Sisa habis — semua titik pesanan ini sudah dicatat. Pencatatan dikunci.</Notice>}
      {canInput && <Inputs it={it} pcs={pcs} setPcs={onPcs} titik={titik} setTitik={setTitik} auto={isAuto} />}
      {it?.is_supervisor && it.capacity_source === "titik_operator" && <OwnerTitikFix it={it} reload={load} />}
      {canInput && <div className="bcl-result" data-testid="claim-preview"><small>Hasil kerja saya</small>
        <b>{Number(pcs) || 0} pcs · {Number(titik) || 0} titik bordir</b></div>}
      {canInput && <small className="bcl-sub">Target ditampilkan jika tersedia dan terverifikasi.</small>}
      {(err || (canInput && (pcs || titik) && invalid)) && <small className="bcl-err" data-testid="claim-error">{err || invalid}</small>}
      {ok && <small className="bcl-ok" data-testid="claim-ok">{ok}</small>}
      {canInput && <button className="primary bcl-save" onClick={save} disabled={busy || !!invalid} data-testid="claim-save">{busy ? "Menyimpan…" : finalize ? finalize.label : "Simpan Hasil"}</button>}
      {finishOnly && <button className="primary bcl-save" disabled={busy} onClick={runFinalize} data-testid="claim-finish-only">Selesai</button>}
      {finalize && !finalize.finish && it && (hasMine || finalize.allowEmpty) && <button className="soft-btn bcl-save" disabled={busy} onClick={runFinalize} data-testid="claim-finalize-only">
        {hasMine ? `${finalize.label.replace("Simpan & ", "")} (hasil sudah tercatat)` : `${finalize.label.replace("Simpan & ", "")} tanpa hasil baru`}</button>}
      {it?.claims?.length > 0 && <div className="bcl-list" data-testid="claim-list"><b>Hasil yang sudah tercatat</b>{it.claims.map(c => <ClaimRow key={c.id} c={c} reload={load} />)}</div>}
      {it && !finalize && <FinishBox it={it} reload={load} onChanged={onChanged} />}
    </div>
  </div>;
}
